var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h4',{staticClass:"mb-1 pl-2 font-weight-bold"},[_vm._v("Gift Information")]),_c('span',[_vm._v("Date: "+_vm._s(_vm.details.created_at))])]),_vm._v(" "+_vm._s(_vm.details)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }